'use client'

import Link from 'next/link'
import Image from 'next/image'
import AddToWishlistButton from '../homes/home-9/BestSelling/AddToWishlistButton'
import styles from './ShopPageProductCard.module.css'

export default function ShopPageProductCard({
  elm,
  i,
  currentPage,
  storeInfo,
  cardBorderEnable,
  cardBorderWidth,
  cardBorderColor,
  cardBorderRound,
  addingId,
  handleAddClick,
  isAddedToCartProducts,
  isOutOfStock,
  setPickerOpen,
  sourceUrl,
}) {
  const productUrl = sourceUrl

  const pictures = Array.isArray(elm?.PictureData)
    ? elm.PictureData.filter((x) => x?.Name)
    : []

  const hasDiscount =
    elm?.SuggestPrice &&
    elm?.Price &&
    Number(elm.Price) < Number(elm.SuggestPrice)

  const wishlistButtonPosition = storeInfo?.WishlistButtonPosition
  const cartButtonPosition = storeInfo?.CartButtonPosition

  // 判斷預購商品與售完商品
  const isPreorder = elm?.IsPreorder === true
  const soldOut = isOutOfStock(elm)
  const canAddToCart = isPreorder || !soldOut

  // 圖片的類型
  const imageAspectType = storeInfo?.ImageAspectType ?? '2'

  return (
    <div className="product-card-wrapper px-2 pb-3">
      <div
        className={styles.card}
        style={{
          border: cardBorderEnable
            ? `${cardBorderWidth}px solid ${cardBorderColor}`
            : undefined,
          borderRadius: cardBorderEnable ? `${cardBorderRound}px` : undefined,
        }}
      >
        <div className={styles.imageArea}>
          <Link
            href={productUrl}
            scroll={false}
            className={`${styles.imageLink} ${
              String(imageAspectType) === '1'
                ? styles.squareImageLink
                : styles.rectangleImageLink
            }`}
          >
            {pictures?.[0]?.Name ? (
              <Image
                src={pictures[0].Name}
                alt={elm?.ProductName || 'product'}
                fill
                sizes="(max-width: 576px) 50vw, (max-width: 992px) 33vw, 25vw"
                className={`${styles.productImage} ${
                  String(imageAspectType) === '1'
                    ? styles.squareProductImage
                    : styles.rectangleProductImage
                }`}
                priority={currentPage === 1 && i < 4}
                loading={currentPage === 1 && i < 4 ? 'eager' : 'lazy'}
                placeholder="empty"
              />
            ) : (
              <div
                className={`${styles.noImage} ${
                  String(imageAspectType) === '1'
                    ? styles.squareImageLink
                    : styles.rectangleImageLink
                }`}
              >
                No Image
              </div>
            )}
          </Link>

          {wishlistButtonPosition === 'Image' && (
            <>
              {storeInfo?.WishlistButtonEnable && (
                <div className={styles.wishlistBox}>
                  <AddToWishlistButton
                    Product={elm}
                    type="2"
                    WishlistButtonPosition={wishlistButtonPosition}
                  />
                </div>
              )}
            </>
          )}

          {cartButtonPosition === 'Image' && (
            <>
              {storeInfo?.CartButtonEnable && (
                <button
                  type="button"
                  className={styles.addCartBtn}
                  onClick={() => handleAddClick(elm)}
                  disabled={addingId === elm.ProductID || !canAddToCart}
                  title={
                    !canAddToCart
                      ? '補貨中'
                      : isAddedToCartProducts(elm.ProductID)
                        ? '已加入購物車'
                        : '加入購物車'
                  }
                >
                  {addingId === elm.ProductID
                    ? '處理中...'
                    : !canAddToCart
                      ? '補貨中'
                      : isAddedToCartProducts(elm.ProductID)
                        ? '已加入購物車'
                        : '加入購物車'}
                </button>
              )}
            </>
          )}

          <div className={styles.labels}>
            {elm?.isNew && <span className={styles.newLabel}>NEW</span>}

            {elm?.discont && (
              <span className={styles.saleLabel}>-{elm.discont}%</span>
            )}
          </div>

          {/* {storeInfo?.CartButtonEnable && (
            <div className={styles.quickViewBox}>
              <QuickViewButton Product={elm} />
            </div>
          )} */}
        </div>

        <div className={styles.infoArea}>
          <h6 className={styles.productTitle}>
            <Link href={productUrl} scroll={false}>
              {elm.ProductName} {elm?.IsPreorder && ' (預購)'}
            </Link>
          </h6>

          <div className={styles.priceRow}>
            <div className={styles.priceBox}>
              {hasDiscount ? (
                <div className="d-flex flex-column">
                  <span className={styles.oldPrice}>
                    NT$ {Number(elm.SuggestPrice).toLocaleString()}
                  </span>
                  <span className={styles.salePrice}>
                    NT$ {Number(elm.Price).toLocaleString()}
                  </span>
                </div>
              ) : (
                <span className={styles.normalPrice}>
                  NT${' '}
                  {Number(elm.SuggestPrice ?? elm.Price ?? 0).toLocaleString()}
                </span>
              )}
            </div>

            {(storeInfo?.WishlistButtonPosition === 'Price' ||
              storeInfo?.CartButtonPosition === 'Price') && (
              <div className={styles.priceActionBox}>
                {storeInfo?.CartButtonEnable &&
                  storeInfo?.CartButtonPosition === 'Price' &&
                  (!canAddToCart ? (
                    <span className={styles.priceSoldOutText}>補貨中</span>
                  ) : (
                    <button
                      type="button"
                      className={styles.priceCartBtn}
                      onClick={() => handleAddClick(elm)}
                      disabled={addingId === elm.ProductID}
                      title={
                        addingId === elm.ProductID
                          ? '處理中...'
                          : isAddedToCartProducts(elm.ProductID)
                            ? '已加入購物車'
                            : '加入購物車'
                      }
                    >
                      {addingId === elm.ProductID ? (
                        <span className={styles.cartLoadingText}>...</span>
                      ) : (
                        <svg
                          className={styles.cartIcon}
                          viewBox="0 0 24 24"
                          fill="none"
                          aria-hidden="true"
                        >
                          <path
                            d="M6.2 6.5h15.1l-1.6 8.2H8L6.2 6.5Z"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M6.2 6.5L5.4 3H3"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                          />
                          <circle
                            cx="9.2"
                            cy="20"
                            r="1.4"
                            stroke="currentColor"
                            strokeWidth="2"
                          />
                          <circle
                            cx="18.2"
                            cy="20"
                            r="1.4"
                            stroke="currentColor"
                            strokeWidth="2"
                          />
                        </svg>
                      )}
                    </button>
                  ))}
                {storeInfo?.WishlistButtonEnable &&
                  storeInfo?.WishlistButtonPosition === 'Price' && (
                    <AddToWishlistButton
                      Product={elm}
                      type="2"
                      WishlistButtonPosition={wishlistButtonPosition}
                    />
                  )}
              </div>
            )}
          </div>

          {elm?.colors && (
            <div className={styles.colorRow}>{/* <ColorSelection /> */}</div>
          )}

          {elm?.reviews && (
            <div className={styles.reviewRow}>
              <div className={styles.stars}>
                {/* <Star stars={elm.rating} /> */}
              </div>
              <span className={styles.reviewText}>{elm.reviews}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
